var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2330 4675 c-327 -55 -604 -198 -833 -431 -199 -203 -334 -451 -399 -737 -18 -83 -21 -138 -28 -542 -9 -588 -2 -561 -247 -968 -147 -244 -171 -298 -179 -399 -20 -229 123 -440 344 -508 60 -19 93 -20 498 -20 l434 0 0 -32 c1 -66 31 -175 71 -258 79 -162 244 -293 419 -334 83 -20 217 -20 300 0 175 41 340 172 419 334 40 83 70 192 71 258 l0 32 433 0 c369 0 441 2 488 16 88 26 150 63 215 128 129 129 174 312 119 492 -8 28 -74 150 -146 270 -257 429 -250 400 -260 989 -4 251 -12 471 -18 497 -40 179 -74 278 -142 413 -207 415 -616 717 -1077 796 -133 22 -362 24 -482 4z m355 -416 c233 -29 434 -122 601 -281 105 -100 166 -183 230 -313 98 -203 114 -313 114 -821 0 -358 7 -429 56 -586 39 -126 78 -202 227 -451 75 -126 137 -239 137 -251 0 -12 -6 -31 -14 -42 -14 -19 -41 -19 -1476 -19 -1435 0 -1462 0 -1476 19 -8 11 -14 30 -14 42 0 11 67 133 148 271 153 258 197 352 240 513 24 92 25 108 33 545 8 471 12 515 59 655 110 328 385 591 717 685 149 42 270 52 418 34z m82 -3231 c-18 -132 -181 -213 -302 -151 -67 35 -115 104 -115 168 l0 25 211 0 212 0 -6 -42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.984cdd3b0e64a033fcf85bb85dae4c79.svg";
export { ForwardRef as ReactComponent };